import { useLang } from '@/i18n';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoSectionCarousel from 'eco-design/sections/eco-section-carousel';
import { useEffect, useRef, useState } from 'react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import { Swiper as SwiperType } from 'swiper/types';
import styles from './index.module.scss';
interface cardItem {
    pc: string;
    icon: string;
    title: any;
    desc: any;
}

export default function Section2JP() {
    const { t } = useLang('dp3.landing.section2');
    const [displayCardList, setDisplayCardList] = useState<cardItem[][]>([]);
    const [swiperDom, setSwiperDom] = useState<SwiperType>();
    const swiperRef = useRef<SwiperType>();

    const cardList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300901200/blog_01.jpg',
            icon: '',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300899780/blog_01%20(1).jpg',
            icon: '',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300901587/blog_01%20(2).jpg',
            icon: '',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300899945/blog_01%20(3).jpg',
            icon: '',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300900664/blog_01%20(4).jpg',
            icon: '',
            title: t('item5_title'),
            desc: t('item5_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300902736/blog_01%20(5).jpg',
            icon: '',
            title: t('item6_title'),
            desc: t('item6_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300902487/blog_01%20(6).jpg',
            icon: '',
            title: t('item7_title'),
            desc: t('item7_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300902136/blog_01%20(7).jpg',
            icon: '',
            title: t('item8_title'),
            desc: t('item8_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300901849/blog_01%20(8).jpg',
            icon: '',
            title: t('item9_title'),
            desc: t('item9_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300900975/blog_01%20(9).jpg',
            icon: '',
            title: t('item10_title'),
            desc: t('item10_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300900431/blog_01%20(10).jpg',
            icon: '',
            title: t('item11_title'),
            desc: t('item11_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300900171/blog_01%20(11).jpg',
            icon: '',
            title: t('item12_title'),
            desc: t('item12_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300902918/blog_01%20(12).jpg',
            icon: '',
            title: t('item13_title'),
            desc: t('item13_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300901346/blog_01%20(13).jpg',
            icon: '',
            title: t('item14_title'),
            desc: t('item14_desc'),
        },
    ];

    const tipKeys = ['tip_desc1', 'tip_desc2', 'tip_desc3', 'tip_desc4'];
    const chunkArray = (arr: cardItem[], size: number): cardItem[][] => {
        if (!Array.isArray(arr) || size <= 0) {
            return [];
        }

        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setDisplayCardList(chunkArray(cardList, 4));
            } else {
                setDisplayCardList(chunkArray(cardList, 6));
            }
        };

        // 初始调用一次
        handleResize();

        // 添加窗口大小变化监听
        window.addEventListener('resize', handleResize);

        // 清理函数
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // 依赖原始 cardList 数组

    // 是否进入视图;
    const enterViewChange = () => {
        const elem = document.querySelector('#section1Card');
        if (elem) {
            const ob1 = new IntersectionObserver((elems) => {
                const elem = elems[0];
                if (elem.isIntersecting) {
                    swiperDom && swiperDom?.slideTo(0, 100, false);
                }
            });
            ob1.observe(elem);
        }
    };
    useEffect(() => {
        enterViewChange();
    }, [swiperDom]);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secne = AniContainer.create({
                triggerElement: '#page-tabSwriper1',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secne.destroy();
            };
        }
    }, []);
    const cardItem = (card: cardItem, cardIndex: number) => {
        return (
            <>
                <div className="card-item" key={cardIndex}>
                    <div className="card-image">
                        {<img src={card.pc} />}
                    </div>
                    <div className="card-info">
                        <div className="card-title">{card.title}</div>
                        <div className="card-desc">{card.desc}</div>
                    </div>
                </div>
            </>
        );
    };

    const [spaceBetweenN, setSpaceBetweenN] = useState(24);

    useEffect(() => {
        const initHandle = () => {
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenN(24);
            } else {
                setSpaceBetweenN(16);
            }
        };
        initHandle();
    }, []);

    return (
        <div
            className={`page-section2JP ${styles.Section2JP} GtmModuleData-section`}
            id="Section2JP"
            data-section-id={'dp3-Section2JP'}
            data-section-title={t('title')}
        >
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="content">
                <div className="eco-content pc-swiper">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={spaceBetweenN}
                        autoplay={{
                            delay: 3000,
                            stopOnLastSlide: false,
                            disableOnInteraction: false,
                        }}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        pagination={{
                            el: '.eco-swiper-pagination',
                            clickable: true,
                        }}
                        scrollbar={{
                            hide: false,
                            draggable: true,
                            dragSize: 32,
                            snapOnRelease: true,
                        }}
                        modules={[Navigation, Pagination, Autoplay, Scrollbar]}
                        onSwiper={(swiper) => {
                            setSwiperDom(swiper);
                            swiperRef.current = swiper;
                        }}
                    >
                        {displayCardList.map((group, groupIndex) => (
                            <SwiperSlide key={groupIndex}>
                                {load && <div className="card-group">{group.map((card, cardIndex) => cardItem(card, cardIndex))}</div>}
                            </SwiperSlide>
                        ))}
                        <div className="eco-swiper-control">
                            <div className="eco-swiper-pagination"></div>
                            <div className="eco-swiper-navigation">
                                <div className="eco-swiper-button-prev">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                                <div className="eco-swiper-button-next">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                            </div>
                        </div>
                    </Swiper>
                </div>
                <div className="h5-content">
                    <EcoSectionCarousel
                        autoplay={{
                            delay: 3000,
                            stopOnLastSlide: false,
                            disableOnInteraction: false,
                            animationNavigationRight: true,
                            viewport: {
                                open: true,
                            },
                        }}
                        swiperAutoPlay={true}
                        items={cardList}
                        pagination
                        getSwiperDom={(data: any) => setSwiperDom(data)}
                    />
                </div>
                <div className="eco-content tip-container">
                    {tipKeys.map((key, index) => (
                        <div className="tip" key={index}>
                            {t.rich(key, {
                                sup: (tx: string) => <span className="number">{tx}</span>,
                            })}
                        </div>
                    ))}
                </div>
                {/* <div className="eco-content tip">{t('tip')}</div> */}
            </div>
        </div>
    );
}
